import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/",
    name: "Main",
    redirect: "/data/train",
    component: () => import("../views/Main.vue"),
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("../views/Home.vue"),
      },
      // 地区管理
      {
        path: "province/:level?/:pid?",
        name: "province",
        component: () => import("../views/CarSite/province.vue"),
      },
      // 添加地区
      {
        path: "province/add",
        name: "addProvince",
        component: () => import("../views/CarSite/provinceAdd.vue"),
      },
      // 编辑地区
      {
        path: "province/edit/:id",
        name: "editProvince",
        component: () => import("../views/CarSite/provinceEdit.vue"),
      },
      // 车站管理
      {
        path: "province/carSite/:province_id/",
        name: "carSite",
        component: () => import("../views/CarSite/carSite.vue"),
      },
      // 车站添加
      {
        path: "province/carSite/add/:province_id",
        name: "addCarSite",
        component: () => import("../views/CarSite/carSiteAdd.vue"),
      },
      // 车站编辑
      {
        path: "province/carSite/edit/:id",
        name: "editCarSite",
        component: () => import("../views/CarSite/carSiteEdit.vue"),
      },
      // 车站管理
      {
        path: "ticket",
        name: "ticket",
        component: () => import("../views/ticket/index.vue"),
      },
      // 来往车站添加
      {
        path: "ticket/add",
        name: "ticketAdd",
        component: () => import("../views/ticket/ticketAdd.vue"),
      },
      // 来往车站编辑
      {
        path: "ticket/edit/:id",
        name: "ticketEdit",
        component: () => import("../views/ticket/ticketEdit.vue"),
      },
      // 停运管理
      {
        path: "ticket/shutdown/:id/:addr?",
        name: "shutdown",
        component: () => import("../views/ticket/shutdown.vue"),
      },

      // 停运设置添加
      {
        path: "ticket/shutdown/add/:id/:addr?",
        name: "shutdown-add",
        component: () => import("../views/ticket/shutdownAdd.vue"),
      },
      // 停运设置编辑
      {
        path: "ticket/shutdown/edit/:id/:ticket_id/:addr?",
        name: "shutdown-edit",
        component: () => import("../views/ticket/shutdownEdit.vue"),
      },
      // 站定管理
      {
        path: "ticket/zhandian/:id/:addr?",
        name: "zhandian",
        component: () => import("../views/ticket/zhandian.vue"),
      },
      // 添加站点
      {
        path: "ticket/zhandian/add/:id/:addr?",
        name: "zhandian-add",
        component: () => import("../views/ticket/zhandianAdd.vue"),
      },
      // 编辑站点
      {
        path: "ticket/zhandian/edit/:id/:addr?",
        name: "zhandian-edit",
        component: () => import("../views/ticket/zhandianEdit.vue"),
      },
      // 绑定管理
      {
        path: "ticket/xinxi/:id/:addr?",
        name: "xinxi",
        component: () => import("../views/ticket/xinxi.vue"),
      },
      // 添加绑定信息
      {
        path: "ticket/xinxi/add/:id/:addr?",
        name: "xinxi-add",
        component: () => import("../views/ticket/xinxiAdd.vue"),
      },
      // 添加绑定信息
      {
        path: "ticket/xinxi/edit/:id/:addr?",
        name: "xinxi-edit",
        component: () => import("../views/ticket/xinxiEdit.vue"),
      },
      // 用户管理
      {
        path: "/user",
        name: "User",
        component: () => import("../views/User.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "用户管理",
          },
        ],
      },
      // 站点组管理
      {
        path: "/siteGroup",
        name: "siteGroup",
        component: () => import("../views/siteGroup/index.vue"),
      },
      // 站点组添加
      {
        path: "/addSiteGroup",
        name: "addSiteGroup",
        component: () => import("../views/siteGroup/add.vue"),
      },
      // 站点组编辑
      {
        path: "/editSiteGroup/:id",
        name: "editSiteGroup",
        component: () => import("../views/siteGroup/edit.vue"),
      },
      // 次卡管理
      {
        path: "/atcard",
        name: "atcard",
        component: () => import("../views/atcard/index.vue"),
      },
      // 次卡添加
      {
        path: "/addAtCard",
        name: "addAtCard",
        component: () => import("../views/atcard/add.vue"),
      },
      // 次卡编辑
      {
        path: "/editAtCard/:id",
        name: "editAtCard",
        component: () => import("../views/atcard/edit.vue"),
      },
      // 次卡/会员卡订单
      {
        path: "/cardOrder/:type",
        name: "cardOrder",
        component: () => import("../views/cardOrder.vue"),
      },
      {
        path: "/cardRideRecord/:user_id",
        name: "cardRideRecord",
        component: () => import("../views/cardRideRecord.vue"),
        meta: [
          {
            name: "会员卡订单",
            url: "/cardOrder/2",
          },
          {
            name: "乘车消费记录",
          },
        ],
      },
      // 会员卡管理
      {
        path: "/vipcard",
        name: "vipcard",
        component: () => import("../views/vipCard/index.vue"),
      },
      // 会员卡添加
      {
        path: "/addVipCard",
        name: "addVipCard",
        component: () => import("../views/vipCard/add.vue"),
      },
      // 会员卡编辑
      {
        path: "/editVipCard/:id",
        name: "editVipCard",
        component: () => import("../views/vipCard/edit.vue"),
      },
      // 订单管理
      {
        path: "/orders",
        name: "orders",
        component: () => import("../views/orders.vue"),
      },
      // 订单管理
      {
        path: "/qrorders",
        name: "qrorders",
        component: () => import("../views/qrorders.vue"),
      },
      // 司机管理
      {
        path: "/drivers",
        name: "drivers",
        component: () => import("../views/drivers.vue"),
      },
      // 提现管理
      {
        path: "/withdrawa",
        name: "withdrawa",
        component: () => import("../views/withdrawa.vue"),
      },
      // 司机认证驳回
      {
        path: "driver_reject/:id",
        name: "driver_reject",
        component: () => import("../views/driver_reject.vue"),
      },
      {
        path: "/bannerHome",
        name: "BannerHome",
        component: () => import("../views/Banner/Home.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "轮播图",
            url: "/bannerHome",
          },
          {
            name: "首页轮播图",
          },
        ],
      },
      // 退款管理
      {
        path: "/refunds",
        name: "refunds",
        component: () => import("../views/refunds.vue"),
      },
      // 维权管理
      {
        path: "/weiquan",
        name: "weiquan",
        component: () => import("../views/weiquan.vue"),
      },
      // 使用指南
      {
        path: "/guides",
        name: "guides",
        component: () => import("../views/guides/index.vue"),
      },
      // 添加指南
      {
        path: "/guidesAdd",
        name: "guidesAdd",
        component: () => import("../views/guides/add.vue"),
      },
      // 编辑指南
      {
        path: "/guidesEdit/:id",
        name: "guidesEdit",
        component: () => import("../views/guides/edit.vue"),
      },
      // 编辑指南
      {
        path: "/others",
        name: "others",
        component: () => import("../views/other.vue"),
      },
      // 车次数据统计
      {
        path: "/data/train",
        name: "trainData",
        component: () => import("../views/trainData.vue"),
      },
      {
        path: "/data/qrorder",
        name: "qrorder",
        component: () => import("../views/qrorder.vue"),
      },
      // 修改密码
      {
        path: "/updatePwd",
        name: "updatePwd",
        component: () => import("../views/updatePwd.vue"),
      },

      {
        path: "/work",
        name: "Work",
        component: () => import("../views/Work.vue"),
        meta: [
          {
            name: "首页",
            url: "/home",
          },
          {
            name: "模块路径",
          },
        ],
      },
      {
        path: "/guideType",
        name: "GuideType",
        component: () => import("../views/GuideType/GuideType.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南分类",
          },
        ],
      },
      {
        path: "/addGuideType",
        name: "AddGuideType",
        component: () => import("../views/GuideType/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南分类",
            url: "/guideType",
          },
          {
            name: "添加分类",
          },
        ],
      },
      {
        path: "/editGuideType/:id",
        name: "EditGuideType",
        component: () => import("../views/GuideType/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南分类",
            url: "/guideType",
          },
          {
            name: "编辑分类",
          },
        ],
      },
      {
        path: "/guide",
        name: "Guide",
        component: () => import("../views/Guide/Guide.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南管理",
          },
        ],
      },
      {
        path: "/addGuide",
        name: "AddGuide",
        component: () => import("../views/Guide/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南管理",
            url: "/guide",
          },
          {
            name: "添加指南",
          },
        ],
      },
      {
        path: "/editGuide/:id",
        name: "EditGuide",
        component: () => import("../views/Guide/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南管理",
            url: "/guide",
          },
          {
            name: "编辑指南",
          },
        ],
      },
      {
        path: "/book",
        name: "Book",
        component: () => import("../views/Book.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "预约管理",
          },
        ],
      },
      {
        path: "/seekType",
        name: "SeekType",
        component: () => import("../views/SeekType/SeekType.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "咨询分类",
          },
        ],
      },
      {
        path: "/addSeekType",
        name: "AddSeekType",
        component: () => import("../views/SeekType/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "咨询分类",
            url: "/seekType",
          },
          {
            name: "添加分类",
          },
        ],
      },
      {
        path: "/editSeekType/:id",
        name: "EditSeekType",
        component: () => import("../views/SeekType/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "咨询分类",
            url: "/seekType",
          },
          {
            name: "编辑分类",
          },
        ],
      },
      {
        path: "/seek",
        name: "Seek",
        component: () => import("../views/Seek.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "办事指南",
            url: "/guide",
          },
          {
            name: "指南管理",
          },
        ],
      },
      {
        path: "/grid",
        name: "Grid",
        component: () => import("../views/Grid/Grid.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "网格管理",
          },
        ],
      },
      {
        path: "/addGrid",
        name: "AddGrid",
        component: () => import("../views/Grid/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "网格管理",
            url: "/grid",
          },
          {
            name: "添加网格",
          },
        ],
      },
      {
        path: "/editGrid/:id",
        name: "EditGrid",
        component: () => import("../views/Grid/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "网格管理",
            url: "/grid",
          },
          {
            name: "编辑网格",
          },
        ],
      },
      {
        path: "/office",
        name: "Office",
        component: () => import("../views/Office/Office.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "两委管理",
          },
        ],
      },
      {
        path: "/addOffice",
        name: "AddOffice",
        component: () => import("../views/Office/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "两委管理",
            url: "/office",
          },
          {
            name: "添加委员",
          },
        ],
      },
      {
        path: "/editOffice/:id",
        name: "EditOffice",
        component: () => import("../views/Office/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "两委管理",
            url: "/office",
          },
          {
            name: "编辑委员",
          },
        ],
      },
      {
        path: "/partyType",
        name: "PartyType",
        component: () => import("../views/PartyType/PartyType.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "党建管理",
            url: "/party",
          },
          {
            name: "党建分类",
          },
        ],
      },
      {
        path: "/addPartyType",
        name: "AddPartyType",
        component: () => import("../views/PartyType/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "党建管理",
            url: "/party",
          },
          {
            name: "党建分类",
            url: "/partyType",
          },
          {
            name: "添加分类",
          },
        ],
      },
      {
        path: "/editPartyType/:id",
        name: "EditPartyType",
        component: () => import("../views/PartyType/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "党建管理",
            url: "/party",
          },
          {
            name: "党建分类",
            url: "/partyType",
          },
          {
            name: "编辑分类",
          },
        ],
      },
      {
        path: "/party",
        name: "Party",
        component: () => import("../views/Party/Party.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "党建管理",
            url: "/party",
          },
          {
            name: "党建信息",
          },
        ],
      },
      {
        path: "/addParty",
        name: "AddParty",
        component: () => import("../views/Party/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "党建管理",
            url: "/party",
          },
          {
            name: "党建信息",
            url: "/party",
          },
          {
            name: "添加信息",
          },
        ],
      },
      {
        path: "/editParty/:id",
        name: "EditParty",
        component: () => import("../views/Party/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "党建管理",
            url: "/party",
          },
          {
            name: "党建信息",
            url: "/party",
          },
          {
            name: "编辑信息",
          },
        ],
      },
      {
        path: "/active",
        name: "Active",
        component: () => import("../views/Active/Active.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "社区动态",
          },
        ],
      },
      {
        path: "/addActive",
        name: "AddActive",
        component: () => import("../views/Active/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "社区动态",
            url: "/active",
          },
          {
            name: "添加动态",
          },
        ],
      },
      {
        path: "/editActive/:id",
        name: "EditActive",
        component: () => import("../views/Active/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "社区动态",
            url: "/active",
          },
          {
            name: "编辑动态",
          },
        ],
      },
      {
        path: "/tenancy",
        name: "Tenancy",
        component: () => import("../views/Tenancy/Tenancy.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "房屋租卖",
          },
        ],
      },
      {
        path: "/addTenancy",
        name: "AddTenancy",
        component: () => import("../views/Tenancy/Add.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "房屋租卖",
            url: "/tenancy",
          },
          {
            name: "添加信息",
          },
        ],
      },
      {
        path: "/editTenancy/:id",
        name: "EditTenancy",
        component: () => import("../views/Tenancy/Edit.vue"),
        meta: [
          {
            name: "模块",
            url: "/user",
          },
          {
            name: "房屋租卖",
            url: "/tenancy",
          },
          {
            name: "编辑信息",
          },
        ],
      },
      {
        path: "/system",
        name: "System",
        component: () => import("../views/System.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "系统设置",
          },
        ],
      },
      {
        path: "/nav",
        name: "Nav",
        component: () => import("../views/Nav/Nav.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "导航设置",
          },
        ],
      },
      {
        path: "/addNav",
        name: "AddNav",
        component: () => import("../views/Nav/Add.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "导航设置",
            url: "/nav",
          },
          {
            name: "添加导航",
          },
        ],
      },
      {
        path: "/editNav/:id",
        name: "EditNav",
        component: () => import("../views/Nav/Edit.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "导航设置",
            url: "/nav",
          },
          {
            name: "编辑导航",
          },
        ],
      },
      {
        path: "/template",
        name: "Template",
        component: () => import("../views/Template.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "模板消息",
          },
        ],
      },
      {
        path: "/suggest",
        name: "Suggest",
        component: () => import("../views/Suggest.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "投诉意见",
          },
        ],
      },
      {
        path: "/manager",
        name: "Manager",
        component: () => import("../views/Manager/Manager.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "管理中心",
          },
        ],
      },
      {
        path: "/addManager",
        name: "AddManager",
        component: () => import("../views/Manager/Add.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "管理中心",
            url: "/system",
          },
          {
            name: "添加管理",
          },
        ],
      },
      {
        path: "/editManager/:id",
        name: "EditManager",
        component: () => import("../views/Manager/Edit.vue"),
        meta: [
          {
            name: "系统",
            url: "/system",
          },
          {
            name: "管理中心",
            url: "/system",
          },
          {
            name: "编辑管理",
          },
        ],
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/404.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // 修改标题
  document.title = "客运管理系统";
  const token = sessionStorage.getItem("token");
  if (to.path == "/login") {
    if (!token) {
      return next();
    } else {
      return next("/data/train");
    }
  } else {
    if (!token) {
      return next("/login");
    }

    if (to.matched.length === 0) {
      return next("/404");
    }

    return next();
  }
});

export default router;
